import { jsx } from "react/jsx-runtime";
import './index.css';function Icon({ children, className = "", ...props }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...props,
      className: `icon iconBase${className ? ` ${className}` : ""}`,
      "data-stb-icon": "true",
      "data-component-info": "pretzel-icon",
      children
    }
  );
}
function Illustration({
  imageUrl,
  alt = "",
  width,
  height,
  lazy = false,
  className = "",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...props,
      className: `illustrationBase${!height ? " autoHeight" : ""}${className ? ` ${className}` : ""}`,
      "data-stb-illustration": "true",
      "data-component-info": "pretzel-illustration",
      children: /* @__PURE__ */ jsx(
        "img",
        {
          src: imageUrl,
          alt,
          title: alt,
          width: width ?? "auto",
          height: height ?? "auto",
          loading: lazy ? "lazy" : "eager"
        }
      )
    }
  );
}
function SystemIcon({
  "aria-label": ariaLabel,
  children,
  className,
  name,
  isPhosphor = false,
  size,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "i",
    {
      ...props,
      className: `systemIconBase${className ? ` ${className}` : ""}`,
      "data-stb-system-icon": "true",
      "data-component-info": `pretzel-system-icon,${isPhosphor ? "phosphor" : "storebrand"},${name}`,
      "data-phosphor-icons": isPhosphor,
      style: size ? {
        height: `${size / 16}rem`,
        width: `${size / 16}rem`,
        fontSize: `${size / 16}rem`,
        lineHeight: `${size / 16}rem`
      } : {},
      role: ariaLabel ? "img" : void 0,
      "aria-hidden": ariaLabel ? void 0 : "true",
      title: ariaLabel,
      translate: "no",
      children: name || children
    }
  );
}
const index = {
  Icon,
  Illustration,
  SystemIcon
};
export {
  Icon,
  Illustration,
  SystemIcon,
  index as default
};
